
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/styles/[id]",
      function () {
        return require("private-next-pages/shop/styles/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/styles/[id]"])
      });
    }
  